<template>
<div class="main my">
  <!-- 场馆管理主页 -->
  <!-- 普通用户跳个人中心页 -->
  <!-- 管理员 -->
  <div>
    <div class="model-box my-model bcg crw tac">
      <h1 class="fs3 mtm clear">{{value.clubInfo?value.clubInfo.title:''}}<i class="vam right mtn van-icon van-icon-arrow" @click="goTo(value.clubInfo.id)"></i></h1>
      <div class="mtw">
        <p class="fs2">当月营收</p>
        <div class="fs6 mtn fwb">￥{{value.monthIncome}}</div>
      </div>
      <van-row class="model-box__bd tac clear">
        <van-col span="8" class="mtw">
            <div class="fs2">练球卡</div>
            <div class="fs4">{{value.practiceCardCnt}}</div>
        </van-col>
        <van-col span="8" class="mtw">
            <div class="fs2">私教课</div>
            <div class="fs4">{{value.ptCourseCnt}}</div>
        </van-col>
        <van-col span="8" class="mtw">
            <div class="fs2">包月课</div>
            <div class="fs4">{{value.monthCardCnt}}</div>
        </van-col>
      </van-row>
    </div>
    <div class="my-model bcw">
      <van-row class="model-box__bd tac clear">
        <van-col v-if="auths && auths.indexOf('staff')!==-1" span="8" class="my-model__item">
          <router-link :to="{ name: 'stafflist'}">
            <i class="my-model__icon iconfont">&#xe68f;</i>
            <div class="fs1 mtn c6">员工管理</div>
          </router-link>
        </van-col>
        <van-col v-if="auths && auths.indexOf('writeOff')!==-1" span="8" class="my-model__item">
          <router-link :to="{ name: 'scancode' }">
            <i class="my-model__icon iconfont">&#xe60c;</i>
            <div class="fs1 mtn c6">签到处理</div>
          </router-link>
        </van-col>
        <van-col v-if="auths && auths.indexOf('practiceCard')!==-1" span="8" class="my-model__item">
          <router-link :to="{ name: 'cardlist'}">
            <i class="my-model__icon iconfont">&#xef0e;</i>
            <div class="fs1 mtn c6">练球卡</div>
          </router-link>
        </van-col>
        <van-col v-if="auths && auths.indexOf('ptCourse')!==-1" span="8" class="my-model__item">
          <router-link :to="{ name: 'privatecourselist'}">
            <i class="my-model__icon iconfont">&#xef4e;</i>
            <div class="fs1 mtn c6">私教课</div>
          </router-link>
        </van-col>
        <van-col v-if="auths && auths.indexOf('monthCard')!==-1" span="8" class="my-model__item">
          <router-link :to="{ name: 'monthcourselist'}">
            <i class="my-model__icon iconfont">&#xe78f;</i>
            <div class="fs1 mtn c6">包月课</div>
          </router-link>
        </van-col>
        <van-col v-if="auths && auths.indexOf('coach')!==-1" span="8" class="my-model__item">
          <router-link :to="{ name: 'mcoachlist'}">
            <i class="my-model__icon iconfont">&#xe69d;</i>
            <div class="fs1 mtn c6">教练管理</div>
          </router-link>
        </van-col>
        <van-col span="8" class="my-model__item">
          <a href="https://www.buole.com/training/#/commonProblem?type=club_system">
            <i class="my-model__icon iconfont">&#xef3c;</i>
            <div class="fs1 mtn c6">使用说明</div>
          </a>
        </van-col>
      </van-row>
    </div>
    <the-tabbar></the-tabbar>
  </div>
</div>
</template>
<script>
import Vue from 'vue';
import func from "@/assets/scripts/func";
import router from '@/router';
import {
  Button,
  Row,
  Col,Toast
} from 'vant';
import TheTabbar from '@/components/TheTabbar';
import TheCopyright from '@/components/TheCopyright';
import MyHead from '@/components/MyHead';

Vue.use(Button).use(Row).use(Col).use(Toast);

export default {
  name: 'Manage',
  components: {
    TheTabbar,
    TheCopyright,
    MyHead
  },
  data() {
    return {
      value: {}, // 当前用户信息
      auths:[], //当前权限
    }
  },
  created(){
    // 获取列表
    this.$http.post('club_manage/index').then(res => {
      if (!res.data.code) {
        this.value = res.data.value
        this.auths = res.data.value.auth //权限
      } else {
        Toast.fail(res.data.message);
      }
    })
  },
  methods: {
    goTo(id){
      if(this.$route.query.type=='admin'){
        // 是管理员
        this.$router.push({ path: 'setclub?clubId='+id})
      }else{
        this.$router.push({ name: 'venueinfo',params: {clubid: id}})
      }
    }
  }
}
</script>
<style lang="less" scoped>
.my-model {
    &__item {
      padding: .15rem;
      border: 1px solid #f5f5f5;
    }
    &__icon {
        font-size: 0.25rem;
        color: #666;
        width: 0.25rem;
        height: .25rem;
        display: block;
        overflow: hidden;
        margin: auto;
    }
    &__icon.scan{
      font-size: .2rem;
      padding-top: .04rem;
    }
    &__icon.help{
      font-size: .22rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/manage/Manage.vue